import React from "react";
import Dropdown, { DropdownMenu, DropdownMenuOption } from "./Dropdown";
import { useNavigate } from "react-router-dom";

export const DynamicDropdown: React.FC<{
  initialText: string | React.ReactNode;
  options: Record<
    string,
    { text: string; class: string; icon?: string; link?: string }
  >;
  onClick: (e: any, k: string | undefined) => void;
  selected?: string;
  variant?: "solid" | "outline";
  clearable?: boolean;
  dimmed?: boolean;
  split?: boolean;
  color?: string;
}> = ({
  options,
  onClick,
  initialText,
  selected,
  variant = "outline",
  clearable = true,
  dimmed = false,
  split = false,
  color = "light",
}) => {
  const dropdownOptions: DropdownMenuOption<any>[] = Object.keys(options).map(
    (k) => ({
      text: options[k].text,
      icon: options[k].icon,
      click: (e: any) => onClick(e, k),
    }),
  );

  const navigate = useNavigate();

  const variantPrefix = variant === "outline" ? "outline-" : "";

  const buttonVariant = selected
    ? variantPrefix + options[selected]?.class
    : variantPrefix + color;

  const buttonClassName = `${
    variant === "outline" ? "btn-white" : ""
  } ${dimmed ? " btn-dim" : ""}`;

  return (
    <Dropdown
      indicator={!split}
      text={
        selected ? (
          <>
            {options[selected]?.icon ? (
              <em className={`icon ${options[selected]?.icon} me-2`} />
            ) : (
              ""
            )}
            {options[selected]?.text}
          </>
        ) : (
          initialText
        )
      }
      variant={buttonVariant}
      className={buttonClassName}
      split={split}
      onButtonClick={(e: any) => {
        if (!selected) {
          onClick(e, undefined);
          return;
        }

        if (options[selected]?.link) {
          navigate(options[selected]?.link as string);
        } else {
          onClick(e, selected);
        }
      }}
    >
      <DropdownMenu
        options={
          selected && clearable
            ? dropdownOptions.concat({
                type: "item",
                text: "Limpiar",
                click: (e: any) => onClick(e, undefined),
                className: "bg-light",
              } as any)
            : dropdownOptions
        }
        className="py-0"
      />
    </Dropdown>
  );
};

export default DynamicDropdown;
